<div class="tab-content work-environment-survey">
  <!-- Page title -->
  <div class="page-title">
    <span translate>WORK_ENVIRONMENT_SURVEY.TITLE</span>
  </div>

  <div class="module-bar">
    <!-- Sub-tabs -->
    <div class="survey-tabs">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            id="wes-tab-overview"
            [class]="getTabClass('overview')"
            (click)="switchTab('overview')"
            role="button"
          >
            <i class="fa fa-tachometer" aria-hidden="true"></i>
            <span translate>WORK_ENVIRONMENT_SURVEY.OVERVIEW.TAB</span>
          </a>
        </li>

        <li class="nav-item" *ngIf="canManageSurveys">
          <a
            id="wes-tab-surveys"
            [class]="getTabClass('surveys')"
            (click)="switchTab('surveys')"
            role="button"
          >
            <i class="fa fa-file-text-o" aria-hidden="true"></i>
            <span translate>WORK_ENVIRONMENT_SURVEY.SURVEYS.TAB</span>
          </a>
        </li>

        <li class="nav-item">
          <a
            id="wes-tab-analysis"
            [class]="getTabClass('analysis')"
            (click)="switchTab('analysis')"
            role="button"
          >
            <i class="fa fa-bar-chart" aria-hidden="true"></i>
            <span translate>WORK_ENVIRONMENT_SURVEY.ANALYSIS.TAB</span>
          </a>
        </li>
      </ul>
    </div>

    <!-- Survey selector, shared by the overview and the analysis -->
    <div class="survey-selector" *ngIf="showSurveySelector">
      <label for="wes-survey-select" translate>
        WORK_ENVIRONMENT_SURVEY.SELECT_SURVEY
      </label>
      <select
        id="wes-survey-select"
        class="form-control"
        [ngModel]="selectedSurveyId"
        (ngModelChange)="onSurveySelected($event)"
      >
        <option *ngFor="let survey of surveys" [ngValue]="survey.Id">
          {{ survey.Title }}
        </option>
      </select>
    </div>
  </div>

  <!-- Tab content -->
  <div class="tab-pane-content">
    <div *ngIf="isTabActive('overview')" class="tab-pane active">
      <survey-overview [surveyId]="selectedSurveyId"></survey-overview>
    </div>

    <div
      *ngIf="isTabActive('surveys') && canManageSurveys"
      class="tab-pane active"
    >
      <survey-list (surveysChanged)="loadSurveys()"></survey-list>
    </div>

    <div *ngIf="isTabActive('analysis')" class="tab-pane active">
      <survey-analysis [surveyId]="selectedSurveyId"></survey-analysis>
    </div>
  </div>
</div>
